import { AuthService } from '@/services/auth.service';

/**
 * toast notification module
 *
 * Política de exibição:
 *   - Toasts são SEMPRE mostrados por padrão.
 *   - Caller que dispara toast a partir de erro de rede esperado (catch de
 *     promise HTTP) deve passar `suppressOffline: true`. Isso evita o spam de
 *     "Network Error" quando o usuário entra em modo avião — comportamento
 *     histórico do app.
 *   - Erros operacionais (validação, disco cheio, regra de negócio etc.) NÃO
 *     devem passar a flag — o usuário precisa enxergá-los independentemente
 *     de estar online ou ter sessão.
 *
 * Antes de mexer: o filtro antigo suprimia TODO toast `type: 'error'` quando
 * offline ou sem refresh token, o que escondia bugs reais. A flag opt-in
 * preserva a intenção original sem mascarar erros legítimos.
 */
export default {
  namespaced: true,
  state: {
    toastsList: []
  },

  mutations: {
    NEW (state, payload) {
      if (payload == null) return;

      // suppressOffline (opt-in): caller declara que esse toast é só ruído
      // quando o usuário está sem rede/sessão. Login screen historicamente
      // foi exceção dessa supressão — preservado via `payload.page === 'login'`.
      if (payload.suppressOffline && payload.page !== 'login') {
        if (!AuthService.hasRefreshToken()) return;
        if (!this.state.dom.isConnected) return;
        // mantém o console.error pra observabilidade quando suprimido —
        // facilita debug "por que não vi o toast?" no devtools
        console.error('[toast suprimido — offline/sem sessão]', payload.message);
      }

      const toast = {
        id: payload.id || new Date().getTime(),
        message: typeof payload === 'string' ? payload : payload.message,
        type: payload.type || 'default',
        duration: payload.duration || 5000,
        // Opcional: ação ao tocar no toast (ex.: push recebido com o app aberto
        // abre a aula). Sem ela, tocar só fecha, como sempre foi.
        onClick: typeof payload.onClick === 'function' ? payload.onClick : null
      };
      state.toastsList.push({ ...toast });
    },
    REMOVE (state, payload) {
      state.toastsList = state.toastsList.filter(({ id }) => id !== payload.id);
    },
    CLEAR_LIST (state) {
      state.toastsList = [];
    }
  }
};
